// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"532":"2a73a1ef87a039ecd42f","678":"b2fb35b57b9bfd4fed7b","883":"8bc81cabbee48a7dae65"}[chunkId] + ".js";
};